import * as BABYLON from 'babylonjs';
import BasicComponent from './BasicComponent';
import * as GUI from 'babylonjs-gui';
import MediaManager from '@/api/MediaManager';

class Video extends BasicComponent {
    getType() { return "Video"; }

    constructor( { id } = {} ) {
        super( { id });

        this.material = undefined;
        this.texture = undefined;
        this.mesh = undefined;
        this.video = undefined;
        this.prefab = undefined;
        this.context = undefined;
        this.width = undefined;
        this.height = undefined;

        this.videoManager = undefined;
        this.videoList = undefined;
        this.videos = undefined;  
        this.listOrientation = undefined;
        this.controllSize = undefined;
        this.ratioX = undefined;
        this.ratioY = undefined;

        this.listGrid = undefined;
        this.currentVideoIndex = 0;
    }   

    setVideoData(){
        this.videos = [
            this.context.$i18n.t("456436"), // Hochleistungsbeschichtung im Durchlauf
            this.context.$i18n.t("456455"), // Höchst Flexible Beschichtungslinie
            this.context.$i18n.t("456474"), // Automatische Beschichtungslinie für die Möbelindustrie
            this.context.$i18n.t("456493"), // Fenster Einzelteil Lackierung
            this.context.$i18n.t("456531"), // Kleberapplikation

            this.context.$i18n.t("456265"), // Ven Spray Smart
            this.context.$i18n.t("456303"), // Ven Spray Comfort
            this.context.$i18n.t("456284"), // Ven spray Perfect
            this.context.$i18n.t("456512"), // VenDryVarioTime
            
            this.context.$i18n.t("456341"), // VSO Produkteinführung
            this.context.$i18n.t("456360"), // VSO Aufbau
            this.context.$i18n.t("456379"), // VSO Inbetriebnahme
            this.context.$i18n.t("456398"), // VSO Rezepte
            this.context.$i18n.t("456417"), // VSO Reinigung
        ];

        this.thumbnails = [
            "Hochleistungsbeschichtung im Durchlauf.jpg",
            "Höchst Flexible Beschichtungslinie.jpg",
            "Automatische Beschichtungslinie für die Möbelindustrie.jpg",
            "Fenster Einzelteil Lackierung.jpg",
            "Kleberapplikation.jpg",

            "Ven Spray Smart.jpg",
            "Ven Spray Comfort.jpg",
            "Ven spray Perfect.jpg", 
            "VenDryVarioTime.jpg",

            "VSO Produkteinführung.jpg",
            "VSO Aufbau.jpg",
            "VSO Inbetriebnahme.jpg",
            "VSO Rezepte.jpg",
            "VSO Reinigung.jpg",
        ];

        this.durrations = [
            "1:21", // Hochleistungsbeschichtung im Durchlauf
            "1:15", // Höchst Flexible Beschichtungslinie
            "1:29", // Automatische Beschichtungslinie für die Möbelindustrie
            "1:26", // Fenster Einzelteil Lackierung
            "2:08", // Kleberapplikation

            "3:51", // Ven Spray Smart
            "3:51", // Ven Spray Comfort
            "2:41", // Ven spray Perfect
            "1:16", // VenDryVarioTime

            "5:08", // VSO Produkteinführung
            "9:09", // VSO Aufbau
            "10:54", // VSO Inbetriebnahme
            "7:28", // VSO Rezepte
            "9:14", // VSO Reinigung

        ];

        this.titles = [
            this.context.$i18n.t("Hochleistungsbeschichtung\nim Durchlauf"),
            this.context.$i18n.t("Höchst Flexible\nBeschichtungslinie"),
            this.context.$i18n.t("Automatische Beschichtungslinie\nfür die Möbelindustrie"),
            this.context.$i18n.t("Fenster Einzelteil\nLackierung"),
            this.context.$i18n.t("Kleber-Applikationslinie"),


            this.context.$i18n.t("Ven Spray Smart"),
            this.context.$i18n.t("Ven Spray Comfort"),
            this.context.$i18n.t("Ven spray Perfect"),
            this.context.$i18n.t("Ven Dry Vario Time"),

            this.context.$i18n.t("Ven Spray One Produkteinführung"),
            this.context.$i18n.t("Ven Spray One Aufbau"),
            this.context.$i18n.t("Ven Spray One Inbetriebnahme"),
            this.context.$i18n.t("Ven Spray One Rezepte"),
            this.context.$i18n.t("Ven Spray One Reinigung"),
        ];
    }

    construct( context, prefab ) {   
        this.context = context;
        this.prefab = prefab;
        
        // Create Base
        const base = super.construct( context, prefab ).getRootNode();
        base.position = prefab.getPosition();
        base.lookAt(new BABYLON.Vector3(0,0,0));

        let base2 = new BABYLON.TransformNode("");
        base2.rotation.x += prefab.getRotationX() * Math.PI / 180;
        base2.rotation.y += prefab.getRotationY() * Math.PI / 180;
        base2.rotation.z += prefab.getRotationZ() * Math.PI / 180;
        base2.parent = base;

        this.width = parseInt(prefab.getWidth());
        this.height = parseInt(prefab.getHeight());
        
        this.setVideoData();
    
        window.addEventListener("languageChange", () => {
            this.setVideoData();

            window.scene.getMeshByName("VideoList").dispose();
            this.createVideoList();
            
            this.updateVideo();
        });

        let videoTexture = new BABYLON.VideoTexture("VisualComponentVideo_Video", MediaManager.getMedia(parseInt(this.videos[0])).getURL(), window.scene, false, false, BABYLON.TRILINEAR_SAMPLINGMODE, { 
            loop: prefab.getLooping() === "true",
            autoPlay: true,
            autoUpdateTexture: true,
            // poster:  prefab.getPoster(), //TODO Poster from CMS
        });
           
        this.texture = videoTexture;
        this.video =  videoTexture.video;
        this.video.volume = prefab.getVolumeScale()/100;
        

        // quickly play and pause video to get first frame as thumbnail
        if(this.video.paused && context.$browserDetect.isChrome){
            console.log("VideoSphere: fixing Chrome thumbnail");

            // muted videos can be autoplayed
            // mute and play Video to get thumbnail, 
            this.video.muted = true;
            let promise = this.video.play();
            
            // After play is successful pause and unmute video again
            promise.then( ()=>{
                this.video.pause();
                this.video.muted = false;
                
                // Ensure autoplay after user interaction for chrome
                if(prefab.getAutoplay() === "true"){
                    window.scene.onPointerDown = () => {
                        this.video.play();
                        window.scene.onPointerDown  = undefined;
                    }
                }
            })
        }

        // Create Material
        this.material = new BABYLON.StandardMaterial("VisualComponentVideo_VideoMaterial" + "_material", window.scene);
        this.material.emissiveTexture = this.texture;
        this.material.disableLighting = true;   
        this.material.opacityTexture = this.texture;     

        // Create Mesh
        this.mesh = BABYLON.MeshBuilder.CreatePlane("Video", {width:  this.width , height: this.height , sideOrientation: BABYLON.Mesh.DOUBLESIDE }, window.scene);
        this.mesh.material = this.material;
        this.mesh.rotation.y = Math.PI;
        this.mesh.parent = base2;
        
        let screenBackground = BABYLON.MeshBuilder.CreatePlane("Background",{width: this.width, height: this.height ,sideOrientation: BABYLON.Mesh.DOUBLESIDE},window.scene);
        screenBackground.material = new BABYLON.StandardMaterial("", window.scene);
        screenBackground.material.diffuseColor = new BABYLON.Color3(0, 0, 0);
        screenBackground.rotation.y = Math.PI;
        screenBackground.position.z = -0.1;
        screenBackground.setEnabled(true);
        screenBackground.parent = this.mesh.parent;


        this.createControlls();
        this.createVideoList();
        
        window.addEventListener('changeVideoGallery',(e) => {
            // Change Volume
            if(e.detail.volume != undefined)
                this.video.volume = e.detail.volume;
            
            // Change Time
            if(e.detail.currentTime != undefined)
                this.video.currentTime = e.detail.currentTime;
            
            // Play/Pause Video
            if(e.detail.paused != undefined && this.video.paused != e.detail.paused)
                e.detail.paused ? this.video.pause() : this.video.play();
            
            // Change Video
            if(e.detail.currentVideoID != undefined && this.currentVideoIndex != e.detail.currentVideoID){
                this.currentVideoIndex = e.detail.currentVideoID;
                for (let i = 0; i < this.listGrid.children.length; i++) {
                    this.listGrid.children[i].thickness = i == this.currentVideoIndex ? 10 : 0;
                    this.listGrid.children[i].children[0].children[3].children[0].source = i == this.currentVideoIndex ? this.context.publicPath + "/media/Venjakob-Messe-2/icons/pause.svg" : this.context.publicPath + "/media/Venjakob-Messe-2/icons/play.svg";
                }
                this.video.src = MediaManager.getMedia(parseInt(this.videos[this.currentVideoIndex])).getURL();
                setTimeout(() => {
                    for (let i = 0; i < this.listGrid.children.length; i++) 
                        if(i == this.currentVideoIndex)
                            this.listGrid.children[i].children[0].children[3].children[0].source =  this.context.publicPath + "/media/Venjakob-Messe-2/icons/pause.svg";
                    this.video.play();
                }, 500);
            }
        });

        base.getChildMeshes().forEach(mesh => {
            mesh.renderingGroupId = 2;
        });

        return base;
    }
    

    createControlls(){
        var ease = new BABYLON.CubicEase();
        ease.setEasingMode(BABYLON.EasingFunction.EASINGMODE_EASEINOUT);
                
        // Create  Play/Pause Button
        // shows play/pause button when you hover over the video element
        var playpauseButton = BABYLON.Mesh.CreatePlane("Play/PauseButton", 20, window.scene);
        playpauseButton.rotation.y = Math.PI;
        playpauseButton.parent =  this.mesh.parent;
        playpauseButton.setEnabled(false);
        var advancedTexture = GUI.AdvancedDynamicTexture.CreateForMesh(playpauseButton);
        var image = new GUI.Image("", this.context.publicPath + "/media/Venjakob-Messe-2/icons/play-button.png");
        advancedTexture.addControl(image);
        playpauseButton.isPickable = false;

        // Black plane before Video that will be visible when you hover over the video
        let background = BABYLON.MeshBuilder.CreatePlane("Background",{width: this.width, height: this.height ,sideOrientation: BABYLON.Mesh.DOUBLESIDE},window.scene);
        background.material = new BABYLON.StandardMaterial("", window.scene);
        background.material.diffuseColor = new BABYLON.Color3(0, 0, 0);
        background.parent = this.mesh.parent;
        background.setEnabled(false);
        background.isPickable = false;

        // videoControlls: slider/timer
        let distance = -this.height*1.5 + 3;
        let videoControllsSize = this.controllSize = 10 + parseInt(this.width > this.height ? this.width : this.height);
        var videoControlls = BABYLON.MeshBuilder.CreatePlane("VideoControlls", {width: videoControllsSize, height: videoControllsSize,sideOrientation: BABYLON.Mesh.DOUBLESIDE}, window.scene);
        videoControlls.parent = this.mesh.parent;
        videoControlls.position.y = distance;
        videoControlls.position.z = 5;
        videoControlls.rotation.y = Math.PI;

        var advancedTexture2 = GUI.AdvancedDynamicTexture.CreateForMesh(videoControlls);
        
        var rect1 = new GUI.Rectangle();
        rect1.verticalAlignment = GUI.Control.VERTICAL_ALIGNMENT_TOP;
        rect1.top = "60px";
        rect1.height = "100px";
        rect1.cornerRadius = 10;
        rect1.thickness = 0;
        rect1.background = rect1.color = "#333333";
        advancedTexture2.addControl(rect1);    

        var grid = new GUI.Grid();   
        grid.addColumnDefinition(1);
        grid.addRowDefinition(20,true);
        grid.addRowDefinition(0.5);
        rect1.addControl(grid); 

        var minColWidth = 0.06;
        var seperatorWidth = 1 - (minColWidth*11.5);
        var gridControls = new GUI.Grid();
        gridControls.addColumnDefinition(minColWidth);
        gridControls.addColumnDefinition(minColWidth*1.5);
        gridControls.addColumnDefinition(minColWidth);
        gridControls.addColumnDefinition(minColWidth);
        gridControls.addColumnDefinition(minColWidth*2);
        gridControls.addColumnDefinition(minColWidth*3);
        gridControls.addColumnDefinition(seperatorWidth);
        gridControls.addColumnDefinition(minColWidth);
        gridControls.addColumnDefinition(minColWidth);
        gridControls.paddingLeft = "20px";
        gridControls.paddingRight = "20px";
        grid.addControl(gridControls,1,0);


        // Zeitleiste
        var sliderUI = new GUI.Slider();
        sliderUI.hoverCursor = "pointer";
        sliderUI.value = 0;
        sliderUI.minimum = 0;
        sliderUI.maximum = 1;
        this.video.onloadedmetadata = function() { sliderUI.maximum = this.duration;};
        sliderUI.height = "20px";
        sliderUI.barOffset = "0px";
        sliderUI.isThumbCircle = true; 
        sliderUI.isThumbClamped = true;
        sliderUI.thumbColor = this.context.primaryColor;
        sliderUI.borderColor = this.context.primaryColor;
        sliderUI.background = "#111111";
        sliderUI.color = this.context.primaryColor;
        grid.addControl(sliderUI,0,0); 
        
        // Skip Buttons
        var skipPrevBtn = new GUI.Button("skipPrevBtn");
        skipPrevBtn.hoverCursor = "pointer";
        skipPrevBtn.thickness = 0;
        var skipPrevImg = new GUI.Image("",this.context.publicPath + "/media/Venjakob-Messe-2/icons/skip_previous.svg");
        skipPrevBtn.width = "48px";
        skipPrevBtn.height = "48px";
        skipPrevBtn.addControl(skipPrevImg);
        gridControls.addControl(skipPrevBtn, 0, 0);

        var skipNextBtn = new GUI.Button("skipNextBtn");
        skipNextBtn.hoverCursor = "pointer";
        skipNextBtn.thickness = 0;
        var skipNextImg = new GUI.Image("",this.context.publicPath + "/media/Venjakob-Messe-2/icons/skip_next.svg");
        skipNextBtn.width = "48px";
        skipNextBtn.height = "48px";
        skipNextBtn.addControl(skipNextImg);
        gridControls.addControl(skipNextBtn, 0, 2);

        //Play/Pause Button 
        var playpauseButton2 = new GUI.Button("playPauseBtn2");
        playpauseButton2.hoverCursor = "pointer";
        playpauseButton2.thickness = 0;
        var playpauseButton2Img = new GUI.Image("",this.context.publicPath + "/media/Venjakob-Messe-2/icons/play.svg");
        playpauseButton2.width = "48px";
        playpauseButton2.height = "48px";
        playpauseButton2.addControl(playpauseButton2Img);
        gridControls.addControl(playpauseButton2, 0, 1);

        // Sound Button
        var soundBtn = new GUI.Button("soundBtn");
        soundBtn.hoverCursor = "pointer";
        soundBtn.thickness = 0;
        var soundImage = new GUI.Image("",this.context.publicPath + "/media/Venjakob-Messe-2/icons/volume_up_white_24dp.svg");
        soundImage.width = "48px";
        soundImage.height = "48px";
        soundBtn.addControl(soundImage);
        gridControls.addControl(soundBtn, 0, 3);
        
        //Volume Slider
        var volumeSlider = new GUI.Slider("volumeSlider");
        volumeSlider.hoverCursor = "pointer";
        volumeSlider.value = 1;
        volumeSlider.minimum = 0;
        volumeSlider.maximum = 1;
        volumeSlider.height = "14px";
        volumeSlider.barOffset = "0px";
        volumeSlider.isThumbCircle = true; 
        volumeSlider.isThumbClamped = true;
        volumeSlider.thumbColor = this.context.primaryColor;
        volumeSlider.borderColor = this.context.primaryColor;
        volumeSlider.background = "#111111";
        volumeSlider.color = this.context.primaryColor;
        gridControls.addControl(volumeSlider,0,4)

        //Video Laufzeit Text
        var time = new GUI.TextBlock();
        // time.fontFamily = this.context.fontFamily;
        time.left = "28px";
        time.text = "0:00/0:00";
        time.color = "#ffffff";
        time.fontSize = 26;
        time.textHorizontalAlignment = GUI.Control.HORIZONTAL_ALIGNMENT_LEFT;
        time.textVerticalAlignment = GUI.Control.VERTICAL_ALIGNMENT_CENTER;
        gridControls.addControl(time, 0, 5);

        // Galerie Button
        var showListBtn = new GUI.Button("showList");
        showListBtn.hoverCursor = "pointer";
        showListBtn.thickness = 0;
        var showListBtnImg = new GUI.Image("",this.context.publicPath + "/media/Venjakob-Messe-2/icons/format_list_bulleted.svg");
        showListBtn.width = "48px";
        showListBtn.height = "48px";
        showListBtn.addControl(showListBtnImg);
        // gridControls.addControl(showListBtn, 0, 7);

        //Popup Video Window
        var openWindowBtn = new GUI.Button("openWindow");
        openWindowBtn.hoverCursor = "pointer";
        openWindowBtn.thickness = 0;
        var openWindowBtnImg = new GUI.Image("",this.context.publicPath + "/media/Venjakob-Messe-2/icons/web_asset.svg");
        openWindowBtn.width = "48px";
        openWindowBtn.height = "48px";
        openWindowBtn.addControl(openWindowBtnImg);
        gridControls.addControl(openWindowBtn, 0, 8);

        this.mesh.actionManager = new BABYLON.ActionManager(window.scene);


        // INTERACTIONS ------------------------------
        let drag = false;
        let volDrag = false;

        var volumeValue = 0;

        // Open Video Gallery inside Pop-Up
        openWindowBtn.onPointerClickObservable.add(() => {
            this.video.pause();
            window.dispatchEvent(new CustomEvent("openURL",{detail: {url: this.video.src}}));
        });

        // Open Video Gallery List
        showListBtn.onPointerClickObservable.add(()=>{
            if(this.videoList.visibility == 1){
                BABYLON.Animation.CreateAndStartAnimation("", this.videoList, "visibility", 30,10, this.videoList.visibility, 0, 0, ease);
                BABYLON.Animation.CreateAndStartAnimation("", this.videoList, "position.y", 30,10, this.videoList.position.y, this.videoList.position.y+10, 0, ease);
            } else {
                BABYLON.Animation.CreateAndStartAnimation("", this.videoList, "visibility", 30,10, this.videoList.visibility, 1, 0, ease);
                BABYLON.Animation.CreateAndStartAnimation("", this.videoList, "position.y", 30,10, this.videoList.position.y-30, this.videoList.position.y-10, 0, ease);
            }
        });

        //Skip Button Function
        skipPrevBtn.onPointerClickObservable.add(()=>{
            this.currentVideoIndex = this.currentVideoIndex == 0 ? this.videos.length-1 : this.currentVideoIndex-1;
            this.updateVideo();
        });
        skipNextBtn.onPointerClickObservable.add(()=>{
            this.currentVideoIndex = this.currentVideoIndex == this.videos.length-1 ? 0 : this.currentVideoIndex+1;
            this.updateVideo();
        });


        // When user starts dragging pause video
        // Detach camera otherwise camera will move while dragging the slider
        sliderUI.onPointerDownObservable.add(() => {
            drag = true;
            window.scene.activeCamera.detachControl();
            this.pauseVideo();
        });    

        // When user stops dragging play video
        // attach camera again
        sliderUI.onPointerUpObservable.add(() => {
            drag = false;
            window.scene.activeCamera.attachControl(document.getElementById("renderCanvas"), true, false,4);
            this.video.currentTime = sliderUI.value;
            time.text = this.updateTime();
            this.playVideo();
        });

        // change currentTime of video when user is dragging the slider 
        // changing cursor to pointer because the cursor somehow changes to default when dragging
        sliderUI.onPointerMoveObservable.add(() => {
            if(drag){
                document.getElementById("renderCanvas").style.cursor = "pointer";
                this.video.currentTime = sliderUI.value;
                time.text = this.updateTime();
            }
        });    
        
        // Volume Behavior
        soundBtn.onPointerClickObservable.add( () => {
            if(!this.video.muted){
                soundBtn.removeControl(soundImage);
                soundImage.source = this.context.publicPath + "/media/Venjakob-Messe-2/icons/volume_off_white_24dp.svg";
                soundBtn.addControl(soundImage);
                volumeSlider.value = 0;
            } else {
                soundBtn.removeControl(soundImage);
                soundImage.source = this.context.publicPath + "/media/Venjakob-Messe-2/icons/volume_up_white_24dp.svg";
                soundBtn.addControl(soundImage);
                if(volumeValue < 0.01){
                    volumeSlider.value = 1;
                } else {
                    volumeSlider.value = volumeValue;
                }
            }
            this.video.volume = volumeSlider.value;
            this.video.muted = !this.video.muted;
        });


        volumeSlider.onPointerDownObservable.add(() => {
            volDrag = true;
            window.scene.activeCamera.detachControl();
        });
        volumeSlider.onPointerUpObservable.add(() => {
            volDrag = false;
            window.scene.activeCamera.attachControl(document.getElementById("renderCanvas"), true, false,4);
            volumeValue = volumeSlider.value;
            this.video.volume = volumeValue;
        }); 
        volumeSlider.onPointerMoveObservable.add(() => {
            if(volDrag){
                document.getElementById("renderCanvas").style.cursor = "pointer";
                this.video.volume = volumeSlider.value;
                if(volumeSlider.value == 0){
                    soundBtn.removeControl(soundImage);
                    soundImage.source = this.context.publicPath + "/media/Venjakob-Messe-2/icons/volume_off_white_24dp.svg";
                    soundBtn.addControl(soundImage);
                    this.video.muted = true;
                } else {
                    if(this.video.muted){
                        soundBtn.removeControl(soundImage);
                        soundImage.source = this.context.publicPath + "/media/Venjakob-Messe-2/icons/volume_up_white_24dp.svg";
                        soundBtn.addControl(soundImage);
                        this.video.muted = false;
                    }
                    volumeValue = volumeSlider.value;
                }
            }
        }); 
        
        // Refresh slider value when currentTime of video changes
        // Dont update slider when user interacts with it
        this.video.ontimeupdate = () =>{
            if(!drag){
                time.text = this.updateTime();
                sliderUI.value = this.video.currentTime;
            }
        };

        // Refrech volume slider value when video volume changes
        this.video.onvolumechange  = () =>{
            volumeSlider.value = this.video.volume;  
        };
        
        // Switch pause to play Button when video is playing
        this.video.onplay = () =>{
            advancedTexture.removeControl(image);
            image = new GUI.Image("", this.context.publicPath + "/media/Venjakob-Messe-2/icons/pause-button.png");
            advancedTexture.addControl(image);
            playpauseButton2.removeControl(playpauseButton2Img);
            playpauseButton2Img = new GUI.Image("",this.context.publicPath + "/media/Venjakob-Messe-2/icons/pause.svg");
            playpauseButton2.addControl(playpauseButton2Img);
        };

        // Switch play to pause Button when video is paused
        this.video.onpause = () =>{
            advancedTexture.removeControl(image);
            image = new GUI.Image("", this.context.publicPath + "/media/Venjakob-Messe-2/icons/play-button.png");
            advancedTexture.addControl(image);
            playpauseButton2.removeControl(playpauseButton2Img);
            playpauseButton2Img = new GUI.Image("",this.context.publicPath + "/media/Venjakob-Messe-2/icons/play.svg");
            playpauseButton2.addControl(playpauseButton2Img);
        };

        // Click: play/pause video
        this.mesh.actionManager.registerAction(new BABYLON.ExecuteCodeAction(BABYLON.ActionManager.OnPickTrigger, () =>{
            this.video.paused ? this.playVideo() : this.pauseVideo();
        }));

        playpauseButton2.onPointerClickObservable.add(()=>{
            this.video.paused ? this.playVideo() : this.pauseVideo();
        })
        
        // hover out: Hide play/pause Button
        this.mesh.actionManager.registerAction(new BABYLON.ExecuteCodeAction(BABYLON.ActionManager.OnPointerOutTrigger, function(){  
            BABYLON.Animation.CreateAndStartAnimation("", playpauseButton, "visibility", 10,2, playpauseButton.visibility, 0, 0, ease, function(){ 
                playpauseButton.setEnabled(false);
            })       
            BABYLON.Animation.CreateAndStartAnimation("", background, "visibility", 10,2, background.visibility, 0, 0, ease, function(){ 
                background.setEnabled(false);
            })     
        }));
        
        // hover over: Display play/pause Button
        this.mesh.actionManager.registerAction(new BABYLON.ExecuteCodeAction(BABYLON.ActionManager.OnPointerOverTrigger, function(){
            playpauseButton.setEnabled(true);
            BABYLON.Animation.CreateAndStartAnimation("", playpauseButton, "visibility", 10,2, 0, 1, 0, ease);
            background.setEnabled(true);
            BABYLON.Animation.CreateAndStartAnimation("", background, "visibility", 10,2, 0, 0.7, 0, ease);
        }));
    }

    createVideoList(){
        var listWinHeight = this.height + 25;
        var listWinWidth = this.height + 25;
        var listMesh = BABYLON.MeshBuilder.CreatePlane("VideoList", {width: listWinWidth, height: listWinHeight, sideOrientation: BABYLON.Mesh.DOUBLESIDE}, window.scene);
        listMesh.position.x = -this.width/2 - listWinWidth/2 - 2;
        listMesh.position.y = -6;
        listMesh.position.z = 30;
        listMesh.rotation.y = 1.1 * Math.PI;
        listMesh.parent = this.mesh.parent;

        this.ratioX = this.controllSize / listWinWidth;
        this.ratioY = this.controllSize / listWinHeight;

        var itemHeightInPx = 130;
        var itemPaddingInPx = 5;

        var advTextureVL = GUI.AdvancedDynamicTexture.CreateForMesh(listMesh);

        var rect3 = new GUI.Rectangle();
        rect3.cornerRadius = 20*this.ratioX;
        rect3.thickness = 1;
        rect3.alpha = 1;
        rect3.background = rect3.color = "#333333";
        advTextureVL.addControl(rect3);

        var scrollPanel = new GUI.ScrollViewer();
        scrollPanel.thickness = 0;
        scrollPanel.color = "transparent";
        scrollPanel.paddingTop = 20*this.ratioY+"px";
        scrollPanel.paddingBottom = 20*this.ratioY+"px";
        scrollPanel.paddingLeft = 30*this.ratioX+"px";
        scrollPanel.paddingRight = "0px";
        scrollPanel.verticalBar.thickness = 0;
        scrollPanel.barSize = 20*this.ratioX;
        scrollPanel.scrollBackground = "transparent";
        advTextureVL.addControl(scrollPanel);

        var listWrapper = new GUI.Rectangle();
        listWrapper.thickness = 0;

        listWrapper.height = (this.videos.length-1)*(itemHeightInPx+4*itemPaddingInPx)*this.ratioY - 190 + "px";
        scrollPanel.addControl(listWrapper);

        var listGrid = new GUI.Grid();
        listGrid.paddingRight = 20*this.ratioX+"px";
        for(var i=0; i < this.videos.length; i++){
            listGrid.addRowDefinition((itemHeightInPx)*this.ratioY,true);
        };
        listWrapper.addControl(listGrid);
        
        for(var i=0; i < this.videos.length; i++){
            var videoListItem = new GUI.Rectangle("videoListItem");
            videoListItem.thickness = this.currentVideoIndex == i ? 5 : 0;
            videoListItem.paddingTop = itemPaddingInPx*this.ratioY + "px";
            videoListItem.paddingBottom = itemPaddingInPx*this.ratioY + "px";
            videoListItem.cornerRadius = 5;
            videoListItem.color = this.context.primaryColor;
            videoListItem.hoverCursor = "Pointer";

            var itemGrid = new GUI.Grid();
            itemGrid.paddingTopInPixels = itemPaddingInPx*this.ratioY;
            itemGrid.paddingBottomInPixels = itemPaddingInPx*this.ratioY;
            itemGrid.paddingLeftInPixels = itemPaddingInPx*this.ratioX;
            itemGrid.paddingRightInPixels = itemPaddingInPx*this.ratioX;
            itemGrid.addColumnDefinition(0.3);
            itemGrid.addColumnDefinition(0.6);
            itemGrid.addColumnDefinition(0.1);
            videoListItem.addControl(itemGrid);

            var image = new GUI.Image("",this.context.publicPath + "/media/Venjakob-Messe-2/thumbnails/" + this.thumbnails[i]);
            itemGrid.addControl(image,0,0);


            var titleValue = this.titles[i];

            var text = new GUI.TextBlock();
            var maxLineLength = titleValue.length > (maxLineLength*2) ? 18 : 16;
            text.fontSize = titleValue.length > (maxLineLength*2) ? 22*this.ratioY : 24*this.ratioY;
            text.text = titleValue; //this.wrapText(titleValue,maxLineLength,maxLineLength*2);
            text.textVerticalAlignment = GUI.Control.VERTICAL_ALIGNMENT_TOP;
            text.textHorizontalAlignment = GUI.Control.HORIZONTAL_ALIGNMENT_LEFT;
            text.left = 20*this.ratioX + "px";
            text.color = "white";
            itemGrid.addControl(text,0,1);

            var textTime = new GUI.TextBlock();
            textTime.textVerticalAlignment = GUI.Control.VERTICAL_ALIGNMENT_BOTTOM;
            textTime.textHorizontalAlignment = GUI.Control.HORIZONTAL_ALIGNMENT_LEFT;
            textTime.fontSize = 20*this.ratioY;
            textTime.left = 20*this.ratioX + "px";
            textTime.text = this.durrations[i]; // ZEIT hier ändern!
            textTime.color = "#ffffff";
            itemGrid.addControl(textTime,0,1);

            var btn = new GUI.Button();
            btn.hoverCursor ="pointer";
            btn.width = 48*this.ratioX+"px";
            btn.height = 48*this.ratioY+"px";
            btn.thickness = 0;
            var btnImg = new GUI.Image("",this.context.publicPath + "/media/Venjakob-Messe-2/icons/play.svg");
            btn.addControl(btnImg);

            itemGrid.addControl(btn,0,2);

            listGrid.addControl(videoListItem,i,0);

            // Interactions
            const t = i;
            videoListItem.onPointerClickObservable.add(()=>{
                this.currentVideoIndex = t;
                this.updateVideo();
            });

            const videoListItemCopy = videoListItem;
            videoListItem.onPointerEnterObservable.add(()=>{
                videoListItemCopy.background = "#444444";
            });
            videoListItem.onPointerOutObservable.add(()=>{
                videoListItemCopy.background = "transparent";
            });
        };
        this.listGrid = listGrid;
        this.videoList = listMesh;

        // Block Zooming on scroll
        listMesh.actionManager = new BABYLON.ActionManager(window.scene);
        listMesh.actionManager.registerAction(new BABYLON.ExecuteCodeAction(BABYLON.ActionManager.OnPointerOverTrigger, () => {
            this.context.setEnableZooming(false);
        }));
        listMesh.actionManager.registerAction(new BABYLON.ExecuteCodeAction(BABYLON.ActionManager.OnPointerOutTrigger, () => {
            this.context.setEnableZooming(true);
        }));

        //detach and attach Camera on scrollbar-hover
        scrollPanel.verticalBar.onPointerDownObservable.add(()=>{
            window.scene.activeCamera.detachControl();
        });
        scrollPanel.verticalBar.onPointerUpObservable.add(()=>{
            window.scene.activeCamera.attachControl(document.getElementById("renderCanvas"), true, false, 4);
        });
    }

    wrapText(string, maxLineLetterCount, maxTitleLetterCount){
        var words = string.split(" ");
        var lineArray = [];
        var lineLetterCount = 0;
        var totalLetterCount = 0;
        for(var i = 0; i<words.length; i++){
            if((totalLetterCount + words[i].length + 2) < maxTitleLetterCount){
                if((lineLetterCount + words[i].length) > maxLineLetterCount){
                    lineArray.push("\n");
                    lineLetterCount = 0;
                } else {
                    lineLetterCount += words[i].length;
    
                }
                totalLetterCount += words[i].length;
                lineArray.push(words[i]);
            } else {
                lineArray.push("...");
                break;
            }
        }
        
        var lineString = "";
        for(var j = 0; j<lineArray.length; j++){
            lineString += lineArray[j];
            if(lineArray[j]!="\n"){
                lineString += " ";
            }
        }
        return lineString;
    }

    updateVideo(){
        for (let i = 0; i < this.listGrid.children.length; i++) {
            this.listGrid.children[i].thickness = i == this.currentVideoIndex ? 10 : 0;
            this.listGrid.children[i].children[0].children[3].children[0].source = i == this.currentVideoIndex ? this.context.publicPath + "/media/Venjakob-Messe-2/icons/pause.svg" : this.context.publicPath + "/media/Venjakob-Messe-2/icons/play.svg";
        }

        this.video.autoplay = false;
        if(!this.video.paused){
            setTimeout(() => {
                this.playVideo();
            }, 500);
        }

        this.video.src = MediaManager.getMedia(parseInt(this.videos[this.currentVideoIndex])).getURL();
    }

    updateTime(){ 
        let currenTime =  this.formatTime(this.video.currentTime);
        let duration = this.formatTime(this.video.duration);
        return currenTime + "/" + duration;
    }

    formatTime(time){
        var mins = Math.floor(time / 60);
        var secs = Math.floor(time - mins * 60);
        return mins + ":" + (secs < 10 ? "0" : "") + secs;
    }
    
    enable(){
        super.enable();    
        this.playVideo();
    }

    disable(){
        super.disable();
        this.pauseVideo();
    }

    playVideo(){
        for (let i = 0; i < this.listGrid.children.length; i++) {
            if(i == this.currentVideoIndex){
                this.listGrid.children[i].children[0].children[3].children[0].source =  this.context.publicPath + "/media/Venjakob-Messe-2/icons/pause.svg";
            }
        }
        this.video.play();
    }

    pauseVideo(){
        for (let i = 0; i < this.listGrid.children.length; i++) {
            if(i == this.currentVideoIndex){
                this.listGrid.children[i].children[0].children[3].children[0].source =  this.context.publicPath + "/media/Venjakob-Messe-2/icons/play.svg";
            }
        }
        this.video.pause();
    }
}

export default Video;

